<script setup>
import { ref, onMounted } from 'vue';
import {get, onDisconnect, onValue, ref as dbRef, serverTimestamp} from 'firebase/database';
import { database } from '@/firebase';
import { isAuthenticated } from "../utils/auth";
import SearchWord from "@/examples/Sidenav/SearchWord.vue";
import {jwtDecode} from "jwt-decode";

const onlineUsers = ref([]);
const todayActiveUsers = ref(0);

const isLoadingUsers = ref(true);
const isLoadingTodayUsers = ref(true);


const loadOnlineUsers = () => {
  isLoadingUsers.value = true;

  const presenceRef = dbRef(database, 'presence');

  onValue(presenceRef, async (snapshot) => {
    const data = snapshot.val();
    if (!data) {
      onlineUsers.value = [];
      isLoadingUsers.value = false;
      return;
    }

    const onlineEntries = Object.entries(data)
      // eslint-disable-next-line no-unused-vars
      .filter(([_, val]) => val.state === 'online');

    const userPromises = onlineEntries.map(async ([uid, val]) => {
      try {
        const userSnapshot = await get(dbRef(database, `users/${uid}`));
        const userData = userSnapshot.val();
        return {
          uid,
          last_changed: val.last_changed,
          name: userData?.name || 'No name',
          favoritesCount: userData.favorites ? Object.keys(userData.favorites).length : 0,
          flashcardsCount: userData.flashcards ? Object.keys(userData.flashcards).length : 0,
        };
      } catch (error) {
        console.error(`Lỗi khi tải tên của UID ${uid}:`, error);
        return {
          uid,
          last_changed: val.last_changed,
          name: 'Lỗi tải tên',
        };
      }
    });

    onlineUsers.value = await Promise.all(userPromises);
    isLoadingUsers.value = false;
  });
};
const formatTimestamp = (timestamp) => {
  const date = new Date(timestamp);
  return new Intl.DateTimeFormat('vi-VN', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
};
const getTodayPresenceLogins = async () => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  const startTimestamp = startOfToday.getTime();

  const presenceRef = dbRef(database, 'presence');
  const snapshot = await get(presenceRef);

  if (!snapshot.exists()) return 0;

  const data = snapshot.val();

  // eslint-disable-next-line no-unused-vars
  const todayUsers = Object.entries(data).filter(([_, val]) => {
    return val.last_changed >= startTimestamp;
  });

  return todayUsers.length;
};
const loadTodayPresenceLogins = async () => {
  isLoadingTodayUsers.value = true;
  todayActiveUsers.value = await getTodayPresenceLogins();
  isLoadingTodayUsers.value = false;
};

onMounted(async () => {
  loadOnlineUsers();
  await loadTodayPresenceLogins();
  if (!isAuthenticated()) {
    let otherUserId = '';
    const token = localStorage.getItem("accessToken");
    if (token) {
      otherUserId = jwtDecode(token).user_id;
      const userStatusRef = await dbRef(database, `presence/${otherUserId}`);

      await onDisconnect(userStatusRef).set({
        state: 'offline',
        last_changed: serverTimestamp()
      });
      localStorage.clear();

    }
  }
  ;
});
</script>
<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <SearchWord></SearchWord>

      <div class="col-lg-12">
        <div class="row mt-4">
          <div class="col-lg-12 mb-lg-0 mb-4">
            <div class="card">
              <div class="p-3 pb-0 card-header">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">🟢 Người dùng đang trực tuyến</h6>
                </div>
              </div>
              <div class="table-responsive">
                <div v-if="isLoadingUsers" class="text-center p-4">
                  <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                  </div>
                </div>
                <table class="table align-items-center" v-if="onlineUsers.length">
                  <tbody>
                    <tr v-for="(user, index) in onlineUsers" :key="index">
                      <td class="w-30">
                        <div class="px-2 py-1 d-flex align-items-center">
                          <div>
                            👤
                          </div>
                          <div class="ms-4">
                            <p class="mb-0 text-xs font-weight-bold">
                              Tên:
                            </p>
                            <h6 class="mb-0 text-sm">{{ user.name }}</h6>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">🟢 Trực tuyến:</p>
                          <h6 class="mb-0 text-sm">{{ formatTimestamp(user.last_changed) }}</h6>
                        </div>
                      </td>
                      <td>
                        <div class="text-center">
                          <p class="mb-0 text-xs font-weight-bold">Yêu thích:</p>
                          <h6 class="mb-0 text-sm">{{ user.favoritesCount }}</h6>
                        </div>
                      </td>
                      <td class="text-sm align-middle">
                        <div class="text-center col">
                          <p class="mb-0 text-xs font-weight-bold">Thẻ ghi nhớ:</p>
                          <h6 class="mb-0 text-sm">{{ user.flashcardsCount }}</h6>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p v-else>Không có người dùng nào đang online.</p>

              </div>
              <div class="p-3 pb-0 card-footer">
                <div class="d-flex justify-content-between">
                  <h6 class="mb-2">👧🏿 Tổng số người dùng hoạt động hôm nay: {{ todayActiveUsers }}</h6>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
